import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../utils/analytics';

export const useAnalytics = () => {
  const location = useLocation();

  // Initialize Google Analytics on mount
  useEffect(() => {
    initGA();
  }, []);

  // Track page views on location change
  useEffect(() => {
    const pagePath = location.pathname + location.search;
    const pageTitle = document.title || 'Quick Runner';

    trackPageView(pagePath, pageTitle);
  }, [location]);
};
